import { render, staticRenderFns } from "./TheAppsDrawer.vue?vue&type=template&id=62b967c3&"
import script from "./TheAppsDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheAppsDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports